import {Component, Input, TemplateRef} from '@angular/core';
import { DialogService } from '../../../service/services/misc/dialog/dialog.service';

@Component({
    selector: 'app-error-strip',
    templateUrl: './error-strip.component.html',
    styleUrls: ['./error-strip.component.scss'],
    standalone: false
})
export class ErrorStripComponent {
	@Input() hasError: boolean;
	@Input() errorText: string;
	@Input() errorMsg: string;
	@Input() popup: boolean;
	@Input() width: string | null;
	@Input() additionalContent: TemplateRef<any>;
	errorMsgShown: boolean;

	constructor(private _dialogService: DialogService) {}

	viewErrorDetails(errorMsg: string) {
	    if (this.popup) {
	        this._dialogService.openMessageBox('Error', errorMsg, 'error');
	    } else {
	        this.errorMsgShown = true;
	    }
	}

	hideErrorDetails() {
	    this.errorMsgShown = false;
	}
}
